import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../core/auth.guard';
import { ExaminationFinalComponent } from './components/final.component';
import { ExaminationMedicalComponent } from './components/medical.component';

const routes: Routes = [
  {
    path: 'examinations/medical',
    component: ExaminationMedicalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'examinations/final',
    component: ExaminationFinalComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExaminationRoutingModule { }
